export default __webpack_public_path__ + "static/media/play_store.59fbaad4.svg";